module.exports = __webpack_public_path__ + "media/images/purchase-step-3-9229933b6d30952b82d1b1da636a2fed.png";